<template>
    <div>
        <div v-if="isLoading" class="mt-2">
            <pulse-loader  loading="loading" color="#d4d5db" size="10px"></pulse-loader>
        </div>
        <slot v-if="!isLoading" :data="data" :update="update" :onload="onload"></slot>
    </div>
</template>

<script>
import Axios from 'axios';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
    props: [
        'get',
        'lead',
        'me',
        'onload',
    ],
    components: {
        PulseLoader
    },
    mounted() {
        let vm = this;

        if(this.onload == 'true') {
            this.getM(this.get);
        } 
        this.$parent.$on('bcRefrescarChild', function(who, val) {
            if(who && who === vm.lead) {
                vm.isLoading = true;
                vm.getM(vm.get + '/' + val);
            }
        });
    },
    data() { return {
        data: [],
        isLoading: false,
    }},
    methods: {
        getM: function(url) {
            setTimeout(() => {
                Axios.get(url).then(res => {
                    this.data = res.data;   
                    this.isLoading = false;                  
                });
            }, 500);
        },
        update: function(val){
            this.$parent.$emit('bcRefrescarSelect', this.me, val);
        },
    }
}
</script>